export function MergeMaps(firstMap, ...maps) {
    const mergedMap = firstMap;
    for (let i = 0, l = maps.length; i < l; i++) {
        const map = maps[i];
        const iterator = map[Symbol.iterator]();
        let result;
        while (!(result = iterator.next()).done) {
            mergedMap.set(result.value[0], result.value[1]);
        }
    }
    return mergedMap;
}
//# sourceMappingURL=merge.js.map